module.exports = __webpack_public_path__ + "static/media/mr_d_base_info.398d09c9.svg";